export const scriptCacheMap = new Map();
import { is } from '../utils';
import { loadCss } from './loadcss';

const BaseLoadTimes = 2;
export const mountScript = (key: string, url: string): Promise<string> => {
  return new Promise((reslove, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (scriptCacheMap.get(url) || (window as any)[key]) {
      return reslove(key);
    }
    const dom = document.createElement('script');
    dom.src = url;
    // dom.async = true;
    dom.crossOrigin = 'anonymous';
    document.body.appendChild(dom);
    dom.onload = () => {
      scriptCacheMap.set(url, true);
      reslove(key);
    };
    dom.onerror = (e) => {
      reject(e);
    };
  });
};

export const mountAnyScript = (
  urls: Record<string, string>,
): Promise<string[]> | Promise<void> => {
  const keys = Object.keys(urls);
  if (keys.length) {
    const asyncList = keys.map((item) => mountScript(item, urls[item]));
    return Promise.all(asyncList);
  }
  return Promise.resolve();
};

export const cssCacheMap = new Map();

export const mountCss = async (url: string): Promise<unknown> => {
  let cssCache = cssCacheMap.get(url);
  let result;
  if (!cssCache) {
    result = new Promise((reslove, reject) => {
      loadCss({
        url,
        id: url,
        callback: () => {
          reslove(url);
        },
      });
    });
  } else {
    result = await result;
  }
  cssCacheMap.set(url, result);
  return result;
};

function requireJs(url: string, name: string) {
  return new Promise((resolve, reject) => {
    const moduleName = [name].join('_');
    if ((window as any)[moduleName]) {
      return resolve((window as any)[moduleName]);
    }

    const js = document.createElement('script');
    js.src = url;
    js.crossOrigin = 'anonymous';
    js.onload = () => {
      if ((window as any)[moduleName]) {
        return resolve((window as any)[moduleName]);
      } else {
        reject(`mount js error: ${url} load error`);
      }
    };

    js.onerror = (e) => {
      reject(e);
    };

    document.body.appendChild(js);
  });
}

(window as any)['_jarvis_loader_'] = requireJs;

export async function requireCdnJS({
  loadTimes = 0,
  url,
  moduleName,
}: {
  url: string;
  moduleName: string;
  loadTimes?: number;
}): Promise<any> {
  if (!moduleName && !url) {
    throw new Error(`moduleName${moduleName} or url${url} is none`);
  }
  try {
    if (loadTimes < BaseLoadTimes) {
      const module: any = await requireJs(url, moduleName);
      if (is.func(module)) return module;
      if (module?.default) {
        return module.default?.default
          ? module.default.default
          : module.default;
      }
      if (is.object(module)) {
        throw new Error(`mount js error: ${url} no return func`);
      }
    } else {
      throw new Error(`mount js error: ${url} load error`);
    }
  } catch (error: any) {
    if (error && loadTimes < BaseLoadTimes) {
      return await requireCdnJS({
        moduleName,
        url,
        loadTimes: ++loadTimes,
      });
    } else {
      throw error;
    }
  }
}
